{
  "open": "Söhbəti aç",
  "unread_one": "{count} oxunmamış mesaj",
  "unread_other": "{count} oxunmamış mesaj",
  "close": "Bağla"
}
